/* src/index.js */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // <--- 1. Import this

// --- FORCE HTTPS ---
if (window.location.protocol === 'http:' && !window.location.host.includes('localhost')) {
    window.location.href = window.location.href.replace('http:', 'https:');
}
// -------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 2. Wrap App in BrowserRouter */}
    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);